


<template lang="jade">

	div.app.noselect
		app-canvas
		app-dialogues

</template>



<script>



	import vue from 'vue'

	vue.prototype.$events = new vue()

	import router from './app-router.js'

	import vueStash from 'vue-stash'
	import appStore from './app-store.js'
	vue.use(vueStash)

	import VTooltip from 'v-tooltip'
	vue.use(VTooltip, {
		defaultDelay : {
			show : 500,
			hide : 50
		},
		defaultBoundariesElement : 'body'
	})

	import appCanvas from './app-canvas.vue'
	import appDialogues from './app-dialogues.vue'

	import home from './components/home/home.vue'



	const $cmp = {
		name : 'app',
		router : router,
		components : {
			appCanvas,
			appDialogues
		},
		data : {
	        store : appStore
	    }
	}

	$cmp.mounted = function() {

		let $this = this
	
	}



	export default $cmp



</script>



<style lang="stylus">

	.app
		position absolute
		top 0px
		left 0px
		right 0px
		bottom 0px
		overflow hidden

		/* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#6c7684+0,2b3038+100 */
		background: #6c7684; /* Old browsers */
		background: -moz-linear-gradient(top, #6c7684 0%, #2b3038 100%); /* FF3.6-15 */
		background: -webkit-linear-gradient(top, #6c7684 0%,#2b3038 100%); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(to bottom, #6c7684 0%,#2b3038 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */

</style>



// WEBPACK FOOTER //
// src/app.vue